module.exports = __webpack_public_path__ + "img/lettre.08b197e1.svg";